import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const vendorAdsApiService = createApi({
  reducerPath: 'vendorAdsApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/purchased-ads/'),
  tagTypes: ['VendorAd'],
  endpoints: (builder) => ({
    // Get all vendor ads (for browsing)
    getAllVendorAds: builder.query({
      query: (args) => ({
        url: 'admin/all',
        method: 'GET',
        params: args
      }),
      providesTags: ['VendorAd'],
      keepUnusedDataFor: 0
    }),
    // Approve a pending ad (charges the saved card + takes it live)
    approveVendorAd: builder.mutation({
      query: (adId) => ({
        url: `${adId}/approve`,
        method: 'PUT'
      }),
      invalidatesTags: ['VendorAd']
    }),
    // Reject a pending ad with an optional reason
    rejectVendorAd: builder.mutation({
      query: ({ adId, reason }) => ({
        url: `${adId}/reject`,
        method: 'PUT',
        body: { reason }
      }),
      invalidatesTags: ['VendorAd']
    }),
    // Revoke an active boost on a purchased ad (admin-only)
    revokeBoost: builder.mutation({
      query: (adId) => ({
        url: `${adId}/boost/revoke`,
        method: 'POST'
      }),
      invalidatesTags: ['VendorAd']
    }),
  })
})

export const {
  useGetAllVendorAdsQuery,
  useApproveVendorAdMutation,
  useRejectVendorAdMutation,
  useRevokeBoostMutation
} = vendorAdsApiService
